export default __webpack_public_path__ + "static/media/100.5991b83f.png";